import get from 'lodash/get';
import RestClient from '../RestClient/RestClient';
import { getHostConfig, RestConfig } from '../Common/RestConfig';

const ERROR_LOG_API_URL = 'accounts/analytics-data/ping';

class LoggerHelper {
    setLogger(logger) {
        this.logger = logger;
    }

    getLogger() { // eslint-disable-line class-methods-use-this
        if (!this.logger) {
            this.logger = console;
        }
        return this.logger;
    }

    createError(errorMessage, apiUrl, exception, status = 0) { // eslint-disable-line class-methods-use-this
        /* istanbul ignore next */
        if (typeof process !== 'undefined' && get(process, 'env.NODE_ENV') === 'test') {
            errorMessage = `${errorMessage.slice(0, 200)} ${get(exception, 'message', '').slice(0, 200)}...truncated for test purposes only`;
            return errorMessage;
        }
        return {
            errorMessage,
            apiUrl,
            exception,
            status,
        };
    }

    logErrorAPI(payload) {
        let config = RestConfig.v1DraftConfig();
        config = getHostConfig(config);
        config.accept = 'application/json';
        config.url = ERROR_LOG_API_URL;
        config.params = { attributes: payload };
        return RestClient.post(config).then(
            /* istanbul ignore next */
            response => response);
    }

    logErrorToBigData = (url, requestMethod, error) => {
        try {
            const preferencesValue = get(window, '__PRELOADED_STATE__.context.preferences', {});
            const kabanaPageName = preferencesValue.kibanaPageName || 'YodaCartCheckout';
            const cluster = preferencesValue.cluster;
            const payload = JSON.parse('{"page": {"pageInfo": {}}}');
            payload.page.pageInfo.pageName = kabanaPageName;
            payload.page.pageInfo.cluster = cluster;
            payload.page.pageInfo.locationURL = window && window.location &&
                `${window.location.host}${window.location.pathname}`;

            payload.page.pageInfo.logApiUrl = url;
            payload.page.pageInfo.logApiMethod = requestMethod;
            payload.page.pageInfo.logMessage = error ? `API_NETWORK_CALL_FAILED : ${JSON.stringify(error.message)}` : 'API_NETWORK_CALL_FAILED';

            const jcpClickApiUrl = preferencesValue.jcpClickApiURL || 'https://api.jcpclick.com/p/collector';
            fetch(jcpClickApiUrl, {
                method: 'post',
                credentials: 'omit',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
                body: JSON.stringify(payload),
            }).then(
                /* istanbul ignore next */
                data => console.log('JCP click stream API request succeeded with JSON response', data),
            ).catch(
                /* istanbul ignore next */
                err => console.log('JCP click stream API request failed', err));
        } catch (err) {
            console.log('JCP click stream API request failed', err);
        }
    }

}

export default new LoggerHelper();
